
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/evaluation",
      function () {
        return require("private-next-pages/ir/evaluation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/evaluation"])
      });
    }
  